import {createSelector} from 'reselect';

import {AppState} from '../../../store';

export const seatLayoutSelector = (state: AppState) => state.seatLayout;
export const selectedSeatLayoutDataSelector = (state:AppState)=> {
    return state.seatLayout.selectedSeatLayoutData
    
  }
  export const ratingAndReviewDataSelector =(state:AppState)=>{
    return state.seatLayout.ratingReviewData;
  }
  export const busDetailSelector = (state:AppState)=> {
    return state.seatLayout.busDetails
    
  }

